module.exports = __webpack_public_path__ + "img/4.fd2e5ae0.png";